import * as Responsive from '../../styles/settings/responsive.scss';

export const XSMALL = parseInt(Responsive.default.xsmall, 10);
export const SMALL = parseInt(Responsive.default.small, 10);
export const MEDIUM = parseInt(Responsive.default.medium, 10);
export const LARGE = parseInt(Responsive.default.large, 10);
export const XLARGE = parseInt(Responsive.default.xlarge, 10);
export const XXLARGE = parseInt(Responsive.default.xxlarge, 10);

export const RESPONSIVE_SIZES = {
  XSMALL,
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
  XXLARGE,
};

export type ResponsiveOptions = keyof typeof RESPONSIVE_SIZES;

export const responsiveMediaAbove = (size: ResponsiveOptions) => {
  return window.innerWidth >= RESPONSIVE_SIZES[size];
};

export const responsiveMediaBelow = (size: ResponsiveOptions) => {
  return window.innerWidth < RESPONSIVE_SIZES[size];
};

export const responsiveQuery = (size: ResponsiveOptions) => {
  return `(min-width: ${RESPONSIVE_SIZES[size]}px)`;
};
